// Bank Transactions Vuex

import state from './bankTransactionStates.js'
import * as getters from './bankTransactionGetters.js'
import * as mutations from './bankTransactionMutations.js'
import * as actions from './bankTransactionActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
